export enum PKV_CHOICE {
  BERUFSSTATUS = 'berufsstatus',
  BERUFSGRUPPE_VORVERSICHERUNG = 'berufsgruppeVorversicherung',
  BEIHILFESAETZE = 'beihilfesaetze',
  KRANKENTAGEGELD_ARBEITNEHMER_AB_TAG = 'krankentagegeldArbeitnehmerAbTag',
  PKV_KRANKENTAGEGELD_AB_TAG = 'krankentagegeldAbTag',
  LEISTUNGSTRAEGER = 'leistungstraeger',
  ALTERSRUECKSTELLUNG = 'altersrueckstellung',
  ERGAENZUNG_GKV = 'ergaenzungGKV',
  GEBUEHRENORDNUNG_AMBULANT = 'gebuehrenordnungAmbulant',
  GEBUEHRENORDNUNG_STATIONAER = 'gebuehrenordnungStationaer',
  GEBUEHRENORDNUNG_ZAHN = 'gebuehrenordnungZahn',
  STATIONAER_LEISTUNG_VOLL = 'stationaerLeistungVoll',
  STATIONAER_LEISTUNG_ZUSATZ = 'stationaerLeistungZusatz',
  ZAHNLEISTUNG = 'zahnLeistung',
  PAUSCHALLEISTUNG = 'pauschalleistung',
  BEITRAGSRUECKERSTATTUNG = 'beitragsrueckerstattung',
  PFLEGEPFLICHTVERSICHERUNG_LEISTUNG = 'pflegepflichtversicherungLeistung',
  BUNDESLAENDER = 'bundeslaender',
}

export enum PKV_META {
  BERUFSSTATUS_HIDE_BERUFSSTATUS = 'hideBerufsstatus',
  IS_ARBEITNEHMER = 'isArbeitnehmer',
  IS_BEAMTER = 'isBeamter',
  BERUFSGRUPPE_IS_STUDENT = 'isStudent',
  BERUFSGRUPPE_HIDE_AG_ANTEIL = 'hideAGAnteil',
  BERUFSGRUPPE_HIDE_AG_ANTEIL_WITHOUT_ARBEITNEHMER = 'hideAGAnteilWithoutArbeitnehmer',

  INVALID = 'invalid',
}
